// Polyfilling globalThis for Safari 10.x and other older browsers
import 'core-js/proposals/global-this';

// Polyfilling ResizeObserver for Safari 10.x and other older browsers
import ResizeObserver from 'resize-observer-polyfill';
if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}
